import Immutable from 'immutable';

const Content: {
  id?: string,
  name: string | null,
  locked: boolean,
  printable: boolean,
  processingStepGroup: string,
  processingStepType: string
} = {
  id: undefined,  // TODO FileInfoLayer should have an id that is set by the server
  name: null,
  locked: false,
  printable: false,
  processingStepGroup: '',
  processingStepType: ''
};

class FileInfoLayer extends Immutable.Record(Content) {
  get processingStep (): string {
    if (!this.processingStepGroup) {
      return '-';
    } else if (!this.processingStepType) {
      return this.processingStepGroup;
    } else {
      return this.processingStepGroup + ' - ' + this.processingStepType;
    }
  }
}

export default FileInfoLayer;
